import { FormGroup } from "@freightsimple/ui-core/FormLayout/FormGroup";
import {
  FormItem,
  type ErrorMessageType,
} from "@freightsimple/ui-core/FormLayout/FormItem";
import { Grid } from "@freightsimple/ui-core/PageLayout/Grid";

import { isDemo } from "@/Environment";
import CreditCardsCardholderName from "@/Shared/CreditCards/CustomComponents/CreditCardsCardholderName";
import CreditCardsCVC from "@/Shared/CreditCards/CustomComponents/CreditCardsCVC";
import CreditCardsExpiration from "@/Shared/CreditCards/CustomComponents/CreditCardsExpiration";
import CreditCardsNumber from "@/Shared/CreditCards/CustomComponents/CreditCardsNumber";

interface CardPanelProps {
  onBillingNameChanged: (_: string) => void;
  onBrandChange?: ((brandName: string) => void) | undefined;
  billingName: string;
  forceValidation: boolean;
  errorMessageForBillingName: ErrorMessageType;
  onCreditCardNumberError: (message: ErrorMessageType) => void;
  onCreditCardExpirationError: (message: ErrorMessageType) => void;
  onCreditCardCVCError: (message: ErrorMessageType) => void;
  errorMessageForCreditCardNumber: ErrorMessageType;
  errorMessageForCreditCardExpiration: ErrorMessageType;
  errorMessageForCreditCardCVC: ErrorMessageType;
  onValidate: () => void;
}

const CreditCardsCardPanel: React.FC<CardPanelProps> = (
  props: CardPanelProps,
) => {
  // On the demo environment, surface the Stripe test card as field help text.
  const cardNumberDescription = isDemo()
    ? "For demo purposes you can enter 4242 4242 4242 4242"
    : undefined;

  return (
    <FormGroup label="Card Details" labelPosition="above">
      <FormItem
        label="Cardholder Name"
        error={props.errorMessageForBillingName}
      >
        <CreditCardsCardholderName
          cardholderName={props.billingName}
          onCardholderNameChanged={props.onBillingNameChanged}
          errorMessage={props.errorMessageForBillingName}
          validated={props.forceValidation}
        />
      </FormItem>
      <FormItem
        label="Card Number"
        description={cardNumberDescription}
        error={props.errorMessageForCreditCardNumber}
      >
        <CreditCardsNumber
          onBrandChange={props.onBrandChange}
          onError={props.onCreditCardNumberError}
          errorMessage={props.errorMessageForCreditCardNumber}
          validated={props.forceValidation}
        />
      </FormItem>
      <Grid columns={2} gap="sm">
        <FormItem
          label="Expiry Date"
          error={props.errorMessageForCreditCardExpiration}
        >
          <CreditCardsExpiration
            onError={props.onCreditCardExpirationError}
            errorMessage={props.errorMessageForCreditCardExpiration}
            forceValidation={props.forceValidation}
          />
        </FormItem>
        <FormItem label="CVC" error={props.errorMessageForCreditCardCVC}>
          <CreditCardsCVC
            onError={props.onCreditCardCVCError}
            errorMessage={props.errorMessageForCreditCardCVC}
            forceValidation={props.forceValidation}
          />
        </FormItem>
      </Grid>
    </FormGroup>
  );
};
export default CreditCardsCardPanel;
